export default {
  "nav.home": "Inicio",
  "nav.spreadsheet": "Hoja de cálculo",
  "nav.articles": "Guías",
  "nav.categories": "Categorías",
  "nav.shoppingGuide": "Guía de compras",

  "hero.seoTitle": "usfans Spreadsheet — Encuentra productos y ahorra | usfanssheet.today",
  "hero.eyebrow": "EL RECURSO DE LA HOJA USFANS",
  "hero.title": "usfans Spreadsheet — Encuentra productos, compara opciones y compra mejor",
  "hero.subtitle": "Explora hallazgos organizados de la hoja usfans, guías de compra y consejos prácticos para ahorrar, todo en un solo lugar.",
  "hero.ctaPrimary": "usfans spreadsheet",
  "hero.ctaSecondary": "compra ahora",
  "hero.trust": "Hallazgos de productos • Consejos para ahorrar • Guías por categoría • Consejos de compra",

  "value.title": "Todo lo que necesitas para comprar mejor, en un solo lugar",
  "value.subtitle": "Nuestro recurso de hoja usfans te ayuda a explorar productos más rápido, entender las categorías y tomar mejores decisiones de compra.",
  "value.card1.title": "Hoja usfans",
  "value.card1.desc": "Encuentra descubrimientos organizados de productos e información útil en todas las categorías.",
  "value.card2.title": "Consejos para ahorrar",
  "value.card2.desc": "Aprende formas prácticas de comparar opciones y estirar tu presupuesto de compras.",
  "value.card3.title": "Guías por categoría",
  "value.card3.desc": "Entiende zapatos, sudaderas, camisetas, chaquetas, bolsos y más antes de comprar.",
  "value.card4.title": "Consejos de compra",
  "value.card4.desc": "Sigue una guía sencilla paso a paso para investigar y elegir productos con confianza.",
  "value.card5.title": "Nuevos hallazgos",
  "value.card5.desc": "Mantente al día con ideas frescas de productos y selecciones de tendencia.",
  "value.card6.title": "Ideal para principiantes",
  "value.card6.desc": "Explicaciones fáciles de seguir, pensadas para quienes usan la hoja por primera vez.",

  "spreadsheet.title": "Explora mejores productos con la hoja usfans",
  "spreadsheet.copy": "Buscar entre miles de productos puede llevar mucho tiempo. Nuestro recurso de hoja usfans organiza hallazgos útiles en categorías fáciles de explorar, para que investigues más rápido y decidas mejor antes de comprar.",
  "spreadsheet.cta": "Explorar la hoja usfans",

  "how.title": "Cómo funciona",
  "how.subtitle": "Un camino sencillo desde la exploración hasta una compra segura.",
  "how.step1": "Elige una categoría",
  "how.step2": "Explora los hallazgos",
  "how.step3": "Revisa los detalles del producto",
  "how.step4": "Compara tus opciones",
  "how.step5": "Aplica los consejos de ahorro",
  "how.step6": "Continúa al sitio principal",

  "popular.title": "Búsquedas populares",
  "popular.subtitle": "Temas que la gente explora más al investigar la hoja usfans.",
  "popular.1": "usfans spreadsheet",
  "popular.2": "hallazgos de usfans spreadsheet",
  "popular.3": "consejos de compra usfans",
  "popular.4": "ahorrar con usfans",
  "popular.5": "categorías usfans",
  "popular.6": "guía usfans",
  "popular.7": "mejores hallazgos usfans",
  "popular.8": "cupón usfans",
  "popular.9": "código de descuento usfans",

  "categories.title": "Explora categorías",
  "categories.subtitle": "Salta directamente a los productos que te interesan en el sitio principal.",
  "categories.dropdownLabel": "Elige una categoría",

  "safety.title": "Investiga antes de comprar",
  "safety.copy": "Una buena hoja debería ayudarte a investigar, no a presionarte para comprar. Compara productos, revisa los detalles y entiende tus opciones antes de decidir.",
  "safety.cta": "Explorar categorías",

  "articles.title": "Guías de la hoja usfans",
  "articles.subtitle": "Artículos originales y detallados para ayudarte a comprar y ahorrar mejor.",

  "final.title": "¿Listo para explorar la hoja usfans?",
  "final.copy": "Empieza con nuestras guías, compara tus opciones y continúa al sitio principal cuando estés listo.",
  "final.cta": "Explorar la hoja usfans",

  "footer.tagline": "Un recurso independiente de hallazgos, guías y consejos de compra de la hoja usfans.",
  "footer.disclaimer": "usfanssheet.today es un recurso informativo independiente. Verifica siempre los enlaces de destino y las ofertas actuales en el sitio principal antes de comprar.",
  "footer.mainSite": "Sitio principal",
  "footer.allRights": "Todos los derechos reservados.",

  "article.backHome": "Volver al inicio",
  "article.related": "Artículos relacionados",
  "article.updated": "Actualizado",

  "notFound.title": "Página no encontrada",
  "notFound.subtitle": "La página que buscas no existe o ha sido movida.",
  "notFound.backHome": "Volver al inicio",

  "categories.shoes": "Zapatos",
  "categories.hoodies": "Sudaderas / Jerséis",
  "categories.tshirts": "Camisetas",
  "categories.jackets": "Chaquetas",
  "categories.pants": "Pantalones / Pantalones cortos",
  "categories.headwear": "Gorros",
  "categories.sets": "Conjuntos",
  "categories.underwear": "Ropa interior",
  "categories.jersey": "Camiseta deportiva",
  "categories.accessories": "Accesorios",
  "categories.bags": "Bolsos",
  "categories.belts": "Cinturones",
  "categories.perfumes": "Perfumes",
  "categories.other": "Otras cosas",
};